import { render } from "./ProfileLayout.vue?vue&type=template&id=9a5bf70a&scoped=true&ts=true&lang=pug"
import script from "./ProfileLayout.vue?vue&type=script&lang=ts"
export * from "./ProfileLayout.vue?vue&type=script&lang=ts"

import "./ProfileLayout.vue?vue&type=style&index=0&id=9a5bf70a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./ProfileLayout.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/profile/profileLayout.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FProfile%2FProfileLayout.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5bf70a"]])

export default __exports__